var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/opt/build/repo/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/opt/build/repo/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/opt/build/repo/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _wrapNativeSuper = require("/opt/build/repo/node_modules/@babel/runtime/helpers/wrapNativeSuper");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/* Timeout */
var NamedError = /*#__PURE__*/function (_Error) {
  "use strict";

  _inherits(NamedError, _Error);

  var _super = _createSuper(NamedError);

  function NamedError() {
    _classCallCheck(this, NamedError);

    return _super.apply(this, arguments);
  }

  _createClass(NamedError, [{
    key: "name",
    get: function get() {
      return this.constructor.name;
    }
  }]);

  return NamedError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var TimeoutError = /*#__PURE__*/function (_NamedError) {
  "use strict";

  _inherits(TimeoutError, _NamedError);

  var _super2 = _createSuper(TimeoutError);

  function TimeoutError() {
    _classCallCheck(this, TimeoutError);

    var message = 'A timeout occurred while communicating with Spotify\'s Web API.';
    return _super2.call(this, message);
  }

  return TimeoutError;
}(NamedError);
/* Web API Parent and fallback error */


var WebapiError = /*#__PURE__*/function (_NamedError2) {
  "use strict";

  _inherits(WebapiError, _NamedError2);

  var _super3 = _createSuper(WebapiError);

  function WebapiError(body, headers, statusCode, message) {
    var _this;

    _classCallCheck(this, WebapiError);

    _this = _super3.call(this, message);
    _this.body = body;
    _this.headers = headers;
    _this.statusCode = statusCode;
    return _this;
  }

  return WebapiError;
}(NamedError);
/** 
 * Regular Error
 * { status : <integer>, message : <string> }
 */


var WebapiRegularError = /*#__PURE__*/function (_WebapiError) {
  "use strict";

  _inherits(WebapiRegularError, _WebapiError);

  var _super4 = _createSuper(WebapiRegularError);

  function WebapiRegularError(body, headers, statusCode) {
    _classCallCheck(this, WebapiRegularError);

    var message = 'An error occurred while communicating with Spotify\'s Web API.\n' + 'Details: ' + body.error.message + '.';
    return _super4.call(this, body, headers, statusCode, message);
  }

  return WebapiRegularError;
}(WebapiError);
/**
 * Authentication Error 
 * { error : <string>, error_description : <string> }
 */


var WebapiAuthenticationError = /*#__PURE__*/function (_WebapiError2) {
  "use strict";

  _inherits(WebapiAuthenticationError, _WebapiError2);

  var _super5 = _createSuper(WebapiAuthenticationError);

  function WebapiAuthenticationError(body, headers, statusCode) {
    _classCallCheck(this, WebapiAuthenticationError);

    var message = 'An authentication error occurred while communicating with Spotify\'s Web API.\n' + 'Details: ' + body.error + (body.error_description ? ' ' + body.error_description + '.' : '.');
    return _super5.call(this, body, headers, statusCode, message);
  }

  return WebapiAuthenticationError;
}(WebapiError);
/**
 * Player Error 
 * { status : <integer>, message : <string>, reason : <string> }
 */


var WebapiPlayerError = /*#__PURE__*/function (_WebapiError3) {
  "use strict";

  _inherits(WebapiPlayerError, _WebapiError3);

  var _super6 = _createSuper(WebapiPlayerError);

  function WebapiPlayerError(body, headers, statusCode) {
    _classCallCheck(this, WebapiPlayerError);

    var message = 'An error occurred while communicating with Spotify\'s Web API.\n' + 'Details: ' + body.error.message + (body.error.reason ? ' ' + body.error.reason + '.' : '.');
    return _super6.call(this, body, headers, statusCode, message);
  }

  return WebapiPlayerError;
}(WebapiError);

module.exports = {
  WebapiError: WebapiError,
  TimeoutError: TimeoutError,
  WebapiRegularError: WebapiRegularError,
  WebapiAuthenticationError: WebapiAuthenticationError,
  WebapiPlayerError: WebapiPlayerError
};